__turbopack_context__.v({
  "footer": "Gw0v3a_footer",
  "footerButtons": "Gw0v3a_footerButtons",
  "footerTotalBreakdown": "Gw0v3a_footerTotalBreakdown",
  "footerTotalCount": "Gw0v3a_footerTotalCount",
  "footerTotalRow": "Gw0v3a_footerTotalRow",
});
